import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {
    UploadFailedReasonEnum,
    UploadInstance
} from '@mintdata-wsp/common/state/ui/visualDesigner/SurfaceFileUploadState';
import {FileUploadToastData} from '@mintdata-wsp/common/state/ui/visualDesigner/ToastData';
import {ProgressBar} from '@mintdata-wsp/wsp/ui/components/general/ProgressBar';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {when} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./FileUploadToast.less');
const cx = classnames.bind(styles);

export interface IFileUploadToastProps
{
    toast:FileUploadToastData;
    onClose?:() => void;
    onCancel?:() => void;
    onAutoHide?:() => void;
}

@observer
export class FileUploadToast extends React.Component<IFileUploadToastProps>
{
    public componentDidMount()
    {
        const {toast, onAutoHide} = this.props;

        when(
            () => !toast.uploadInstance.isUploading,
            () => onAutoHide()
        );
    }

    public render():JSX.Element
    {
        const {toast} = this.props;
        const {uploadInstance} = toast;

        // if( uploadInstance.isUploading )
        //     return this._renderUploading();

        if( uploadInstance.isUploadFailed )
            return this._renderUploadFailed();

        // if( uploadInstance.isUploadSuccess )
        //     return this._renderUploadSuccess();

        return null;
    }

    private _renderUploading():JSX.Element
    {
        const {uploadInstance} = this.props.toast;

        return (
            <div className={cx('base')}>
                <div className={cx('header')}>
                    <MDIcon name={MDIcons.common.Info} className={cx('iconInProgress')} />
                    <div className={cx('title')}>
                        {'Uploading file...'}
                    </div>
                </div>
                <div className={cx('body')}>
                    {this._renderFilename(uploadInstance)}
                    <ProgressBar
                        progressTrackClassName={cx('progressTrackClassName')}
                    />
                </div>
                <div className={cx('footer')}>
                    <WSPButton
                        className={cx('button')}
                        style={ButtonStyle.SimpleSecondary}
                        caption={'Cancel'}
                        onClick={this._handleUploadingCancelClick}
                    />
                </div>
            </div>
        );
    }

    private _renderUploadFailed():JSX.Element
    {
        const {uploadInstance} = this.props.toast;

        return (
            <div className={cx('base')}>
                <div className={cx('header')}>
                    <MDIcon name={MDIcons.common.Info} className={cx('iconFailed')} />
                    <div className={cx('title')}>
                        {'Upload error'}
                    </div>
                </div>
                <div className={cx('body')}>
                    {this._renderFilename(uploadInstance)}
                    {this._renderFailedReason(uploadInstance)}
                </div>
                <div className={cx('footer')}>
                    <WSPButton
                        className={cx('button')}
                        style={ButtonStyle.Raised}
                        caption={'Ok, got it'}
                        onClick={this._handleCloseButtonClick}
                    />
                </div>
                {this._renderCloseButton()}
            </div>
        );
    }

    private _renderUploadSuccess():JSX.Element
    {
        const {uploadInstance} = this.props.toast;

        return (
            <div className={cx('base')}>
                <div className={cx('header')}>
                    <MDIcon name={MDIcons.common.Info} className={cx('iconSuccess')} />
                    <div className={cx('title')}>
                        {'Upload success'}
                    </div>
                </div>
                <div className={cx('body')}>
                    <div className={cx('fileUploaded')}>{`${uploadInstance.file.name} was uploaded`}</div>
                </div>
                <div className={cx('footer')}>
                    <WSPButton
                        className={cx('button')}
                        style={ButtonStyle.Raised}
                        caption={'Ok, got it'}
                        onClick={this._handleCloseButtonClick}
                    />
                </div>
                {this._renderCloseButton()}
            </div>
        );
    }

    private _renderCloseButton():JSX.Element
    {
        return (
            <WSPButton
                icon={MDIcons.common.Close}
                style={ButtonStyle.SimpleSecondary}
                className={cx('closeBtn')}
                onClick={this._handleCloseButtonClick}
            />
        );
    }

    private _renderFilename(uploadInstance:UploadInstance):JSX.Element
    {
        const {file} = uploadInstance;

        return file ? (
            <div className={cx('filename')}>{uploadInstance.file.name}</div>
        ) : null;
    }

    private _renderFailedReason(uploadInstance:UploadInstance):JSX.Element
    {
        const {failedReason} = uploadInstance;

        if( failedReason === UploadFailedReasonEnum.MultipleIsNotAllowed )
            return <div>{'Please upload one file at a time.'}</div>;

        if( failedReason === UploadFailedReasonEnum.FileTypeIsNotSupported )
            return <div>{'Only Image and Video files are supported.'}</div>;

        return <div>{failedReason}</div>;
    }

    @bind
    private _handleCloseButtonClick()
    {
        if( this.props.onClose )
            this.props.onClose();
    };

    @bind
    private _handleUploadingCancelClick()
    {
        if( this.props.onCancel )
            this.props.onCancel();
    }
}
